import { useCallback, useMemo } from "react";
import { PaymentMethod } from "@orb-labs/types";
import { Fraction } from "@uniswap/sdk-core";
const ONCHAIN_PRESETS = [
    { fraction: new Fraction(1, 10), label: "10%" },
    { fraction: new Fraction(1, 4), label: "25%" },
    { fraction: new Fraction(1, 2), label: "50%" },
    { fraction: new Fraction(1, 1), label: "Max" },
];
const FIAT_PRESETS = [
    { value: 50, label: "$50" },
    { value: 100, label: "$100" },
    { value: 250, label: "$250" },
    { value: 500, label: "$500" },
];
export function useQuickSelectPresets({ paymentMethod, availableFunds, onSetAmount, }) {
    const isOnchain = paymentMethod === PaymentMethod.ONCHAIN_TRANSFER;
    const options = useMemo(() => {
        return isOnchain ? ONCHAIN_PRESETS : FIAT_PRESETS;
    }, [isOnchain]);
    const handleSelect = useCallback((index) => {
        if (isOnchain) {
            if (!availableFunds)
                return;
            const preset = ONCHAIN_PRESETS[index];
            const calculatedAmount = availableFunds.multiply(preset.fraction);
            onSetAmount(calculatedAmount.toFixed(Math.min(2, calculatedAmount.currency.decimals)));
        }
        else {
            const preset = FIAT_PRESETS[index];
            onSetAmount(preset.value.toString());
        }
    }, [isOnchain, availableFunds, onSetAmount]);
    return { options, handleSelect };
}
